import type { SizeOptionWithEdd } from '../../domain/models/CustomizationOptions';
import { getSizeEddDisplay } from '../../utils/sizeSheetDisplay.utils';

interface CustomizationSizeEddLabelProps {
  size: SizeOptionWithEdd;
  nddAvailableSizes: string[] | null;
}

export function CustomizationSizeEddLabel({
  size,
  nddAvailableSizes,
}: CustomizationSizeEddLabelProps) {
  const display = getSizeEddDisplay(size, nddAvailableSizes);

  if (display.variant === 'none' || !display.label) {
    return <span className="text-[13px] text-[#999]">—</span>;
  }

  if (display.variant === 'tomorrow') {
    return (
      <span className="inline-block rounded-[3px] bg-[#59ac59] px-1.5 py-1.5 text-[13px] font-medium leading-none text-white">
        {display.label}
      </span>
    );
  }

  return <span className="text-[13px] font-normal text-[#808080]">{display.label}</span>;
}
